import clsx, { type ClassValue } from "clsx";

/**
 * Class-name joiner.
 *
 * Deliberately just `clsx` — no `tailwind-merge`. Our Tailwind theme replaces
 * the default scales, so twMerge's built-in conflict groups (which are keyed to
 * Tailwind's own class names) would misclassify tokens like `text-sm`
 * (a font size) as a text colour and silently drop one of them. Components here
 * build a complete class list per variant instead of relying on later classes
 * winning.
 */
export const cn = (...inputs: ClassValue[]): string => clsx(inputs);
